declare global {
  interface Window {
    DocumentTouch: never;
  }
}

function isTouchDevice(): boolean {
  return (
    !!(
      typeof window !== 'undefined' &&
      ('ontouchstart' in window ||
        (window.DocumentTouch &&
          typeof document !== 'undefined' &&
          document instanceof window.DocumentTouch))
    ) ||
    !!(
      typeof navigator !== 'undefined' &&
      (navigator.maxTouchPoints ||
        (navigator as Navigator & { msMaxTouchPoints?: number })
          .msMaxTouchPoints)
    )
  );
}

export default isTouchDevice;
